export const VERSION = '1.50.0'
